import { apolloClient } from '../graphql/apollo'
import {
  CREATE_LAB_REPORT,
  UPDATE_LAB_REPORT,
  DELETE_LAB_REPORT
} from '../graphql/queries/LabReportQueries'

export const createLabReport = async labReportCreate => {
  try {
    const report = await apolloClient.mutate({
      mutation: CREATE_LAB_REPORT,
      variables: { labReportCreate }
    })
    return report.data.createLabReport
  } catch (e) {
    console.log(e)
  }
}

export const updateLabReport = async (id, labReportUpdate) => {
  try {
    const report = await apolloClient.mutate({
      mutation: UPDATE_LAB_REPORT,
      variables: { id, labReportUpdate }
    })
    return report.data.updateLabReport
  } catch (e) {
    console.log(e)
  }
}

export const deleteLabReport = async id => {
  try {
    const report = await apolloClient.mutate({
      mutation: DELETE_LAB_REPORT,
      variables: { id }
    })
    return report.data.deleteLabReport
  } catch (e) {
    console.log(e)
  }
}
